import React from 'react';
import { Row, Col } from 'react-bootstrap';

const InvalidLink = () => (
  <div className="main-fullheight">
    <div className="fullheight">
      <Row className="show-grid">
        <Col md={12} className="show-grid-in sorry-head">
          <h1 className="heading">Sorry this link is no longer valid.</h1>
          {/*<h1 className="heading">*/}
          {/*We'd love to reinstate your access!*/}
          {/*</h1>*/}
          {/*<p className="description-form get-touch">*/}
          {/*Click below to regain access.*/}
          {/*</p>*/}
          {/*<div className="form-footer">*/}
          {/*<Col md={12} className="info-button">*/}
          {/*<Button type="submit" bsStyle="primary">*/}
          {/*Subscription*/}
          {/*</Button>*/}
          {/*</Col>*/}
          {/*</div>*/}
        </Col>
      </Row>
    </div>
  </div>
);

export default InvalidLink;



// WEBPACK FOOTER //
// ./src/components/Register/InvalidLink.js